"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageDefinitionFocus = void 0;
/**
 * Defines the characteristics of a message that can be shared between systems, including the type of event that initiates the message, the content to be transmitted and what response(s), if any, are permitted.
 */
var MessageDefinitionFocus = /** @class */ (function () {
    function MessageDefinitionFocus() {
    }
    return MessageDefinitionFocus;
}());
exports.MessageDefinitionFocus = MessageDefinitionFocus;
